import type { Session } from "@/types/auth";

const KEY = "gridcast:session";

let cached: Session | null | undefined;

export function getSession(): Session | null {
	if (cached !== undefined) return cached;
	try {
		const raw = localStorage.getItem(KEY);
		cached = raw ? (JSON.parse(raw) as Session) : null;
	} catch {
		cached = null;
	}
	return cached;
}

export function setSession(session: Session | null) {
	cached = session;
	if (session) localStorage.setItem(KEY, JSON.stringify(session));
	else localStorage.removeItem(KEY);
	document.documentElement.classList.toggle("logged-out", !session);
}
